export default "__VITE_ASSET__DM6HCCc9__"